// Initial balance from the authenticated session; the layout refreshes the wallet.
export let bonesBalance: number | null = null;
export function setBonesBalance(value: unknown): void {
  bonesBalance = typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null;
}
